import React from 'react'
import { twMerge } from 'tailwind-merge'

import { VStackProps } from './stack.type'

import { stackStyle } from './stack.css'

const VStack = <E extends React.ElementType = 'div'>({
  className,
  as,
  align,
  justify,
  children,
  ref,
  ...props
}: VStackProps<E>) => {
  const Element = as || 'div'

  return (
    <Element className={twMerge(stackStyle({ direction: 'vertical', align, justify }), className)} ref={ref} {...props}>
      {children}
    </Element>
  )
}
VStack.displayName = 'VStack'

export default VStack
